import script from "./EngagementBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./EngagementBoard.vue?vue&type=script&setup=true&lang=js"

import "./EngagementBoard.vue?vue&type=style&index=0&id=29170d37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29170d37"]])

export default __exports__